export enum SampleStatus {
  RECOLLECT = 'RECOLLECT',
  SEQUENCING_COMPLETE = 'SEQUENCING_COMPLETE',
  RESULTS_DELIVERED = 'RESULTS_DELIVERED',
  RECEIVED = 'RECEIVED',
  IN_SEQUENCING = 'IN_SEQUENCING',
  AWAITING = 'AWAITING',
}

export interface FetchSamplesParam {
  sampleStatus: SampleStatus[];
  endDate?: Date | undefined | string;
  startDate?: Date | undefined | string;
  studyId?: string;
}

export enum SampleSerieType {
  BLOOD = 'BLOOD',
  SALIVA = 'SALIVA',
  BUCCAL_SWAB = 'BUCCAL_SWAB',
}

export enum SampleCollectionLocation {
  AT_HOME = 'AT_HOME',
  IN_PERSON = 'IN_PERSON',
  REUSE = 'REUSE',
  NOT_AVAILABLE = 'NOT_AVAILABLE',
}
